module.exports = __webpack_public_path__ + "static/img/extra-first.f997eb2.png";